import { Link, Routes, Route, useNavigate } from 'react-router-dom';
import { wait } from '../ulits';

const lookup = require('country-code-lookup');

const baseUrl = `https://randomuser.me/api`;

export function getCountryCodes(countryNames) {
  return countryNames.map((name) => {
    const result = lookup.byCountry(name).iso2;
    return result;
  });
}

export function getLocation(countryCode) {
  const requestOptions = {
    method: 'GET',
    redirect: 'follow',
    mode: 'no-cors', // no-cors, *cors, same-origin
    headers: {
      'Content-Type': 'application/json',
      'Set-Cookie': 'SameSite=None; Secure',
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
  };
  const checkedCountryCode = countryCode === 'GB' ? 'UK' : countryCode;

  return fetch(
    `https://proxy.jsart.pl/https://api.3geonames.org/?json=1&randomland=${checkedCountryCode}`
  )
    .then((response) => response.json())
    .then((data) => [data.nearest.latt, data.nearest.longt])
    .catch((err) => {
      console.error(err); // ! sometimes: SyntaxError: Unexpected token 'F', " Fast Rever"... is not valid JSON
    });
}

let count = 0;
// ! FETCH WITH RETRY:
function fetchRetry(url, delay, tries, fetchOptions = {}) {
  function onError(err) {
    const triesLeft = tries - 1;

    if (!triesLeft) {
      throw err;
    }
    return wait(delay).then(() =>
      fetchRetry(url, delay, triesLeft, fetchOptions)
    );
  }
  count += 1;
  // console.log('Fetching users. Try nr', count);
  return fetch(url, fetchOptions).catch(onError);
}

export function getNewUsers(usersNum = 5) {
  const url = `${baseUrl}/?results=${usersNum}&inc=name,login,gender,dob,location,email,picture&noinfo`;

  return fetchRetry(url, 1000, 3, {
    method: 'GET',
    headers: {
      'Content-type': 'application/json;charset=UTF-8',
      'Set-Cookie': 'HttpOnly;Secure;SameSite=None',
    },
  }).then((response) => response.json());
}
